import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=840000dc&scoped=true&lang=pug&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=840000dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840000dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('840000dc')) {
      api.createRecord('840000dc', component.options)
    } else {
      api.reload('840000dc', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=840000dc&scoped=true&lang=pug&", function () {
      api.rerender('840000dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/certificates/Modal.vue"
export default component.exports